module.exports = __webpack_public_path__ + "static/img/son5_active.d17653ac.png";